import React from "react";
import { useLang, LANGS } from "@/context/LanguageContext";
import { Languages } from "lucide-react";

export default function LanguageSelector({ compact }) {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center gap-1" data-testid="language-selector">
      {!compact && <Languages size={14} style={{ color: "var(--gi-muted)" }} />}
      {LANGS.map(l => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          className="px-2 py-1 text-[11px] font-medium border-b-2 transition-colors"
          style={{
            borderColor: lang === l.code ? "var(--gi-maroon)" : "transparent",
            color: lang === l.code ? "var(--gi-maroon)" : "var(--gi-charcoal-2)",
          }}
          data-testid={`lang-btn-${l.code}`}
          aria-label={`Switch to ${l.label}`}
        >
          {l.native}
        </button>
      ))}
    </div>
  );
}
